import { NgClass } from "@angular/common";
import { Component, inject } from "@angular/core";

import { AboutService } from "@home/services/about.service";
import { rotate, verticalSlideToggle } from "@shared/animations";
import { StatusBadgeConfig, VersionDetails } from "@shared/models";
import { LocalStorage } from "@shared/enums";
import { StatusBadgeComponent } from "@shared/components";

@Component({
  selector: "app-versions",
  standalone: true,
  imports: [NgClass, StatusBadgeComponent],
  templateUrl: "./versions.component.html",
  styleUrl: "./versions.component.scss",
  animations: [rotate, verticalSlideToggle],
})
export class VersionsComponent {
  aboutService = inject(AboutService);

  versions: VersionDetails[] = this.aboutService.getVersions().reverse();
  betaStatus: StatusBadgeConfig = { class: "status beta", text: "Beta" };
  newStatus: StatusBadgeConfig = { class: "status new", text: "New!" };

  onVersionDetailClick(version: VersionDetails) {
    const versions = localStorage.getItem(LocalStorage.Versions);
    if (!versions) return;

    const data = JSON.parse(versions) as VersionDetails[];
    version.isShown = !version.isShown;

    if (version.isShown && version.isNew) {
      version.isNew = false;
      const issue = data.find((d) => d.version === version.version);
      if (issue) issue.isNew = false;
      localStorage.setItem(LocalStorage.Versions, JSON.stringify(data));
    }
  }
}
